var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checked)?_c('van-icon',{attrs:{"name":"checked","size":"var(--fs-ex1)","color":"var(--c1)"}}):_c('van-icon',{attrs:{"name":"circle","size":"var(--fs-ex1)","color":"var(--g5)"}})}
var staticRenderFns = []

export { render, staticRenderFns }